import axios from "./HttpRequestProductDetail";


function getListBundleProduct(mahang) {
   return axios.get('/Products/list_producst_muacung?page_index=0&page_size=10&mahang=' + mahang);
}
function getListBundleProductV2(mahang,makhachang) {
   return axios.get('/Products/list_producst_muacung_v2?page_index=0&page_size=10&mahang=' + mahang+'&makhachang='+makhachang);
}
function getListBundleProductPanigationV2(mahang, page_index,makhachang) {
   return axios.get('/Products/list_producst_muacung?page_index=' + page_index + '&page_size=10&mahang=' + mahang+'&makhachang='+makhachang);
}
function getListBundleProductPanigation(mahang, page_index) {
   return axios.get('/Products/list_producst_muacung?page_index=' + page_index + '&page_size=10&mahang=' + mahang);
}
function getListProductSame(mahang) {
   return axios.get('/Products/Api_BiboOffice_list_tuongtu_func?page_index=0&page_size=100&mahang=' + mahang);
}
function getListProductSamePanigation(mahang, page_index) {
   return axios.get('/Products/Api_BiboOffice_list_tuongtu_func?page_index='+page_index+'&page_size=10&mahang=' + mahang);
}
export { getListBundleProduct, getListProductSame, getListBundleProductPanigation, getListProductSamePanigation ,getListBundleProductV2,getListBundleProductPanigationV2}